export const NAVBAR_MESSAGES = {
  success: {
    CRASH_REPORT_SUCCESS: "navBar.snackSuccessCrashReport",
    THEME_SUCCESS: "navBar.snackSuccessTheme",
    SET_CURRENCY_SUCCESS: "navBar.snackSuccessCurrency",
    ADD_CONTACT_SUCCESS: "navBar.snackSuccessContactAdd",
    DELETE_CONTACT_SUCCESS: "navBar.snackSuccessContactDelete",
    SET_LOCALE_SUCCESS: "navBar.snackSuccessLocale",
    ADD_TOKEN_SUCCESS: "navBar.snackSuccessTokenAdd",
    REMOVE_TOKEN_SUCCESS: "navBar.snackSuccessTokenRemove",
    DOWNLOAD_KEY_SUCCESS: "navBar.snackSuccessDownloadKey",
    CHANGE_NETWORK_SUCCESS: "navBar.snackSuccessNetworkChange",
    SWITCH_ACCOUNT_SUCCESS: "navBar.snackSuccessSwitchAccount",
  },
  error: {
    CRASH_REPORT_FAILED: "navBar.snackFailCrashReport",
    THEME_FAILED: "navBar.snackFailTheme",
    SET_CURRENCY_FAILED: "navBar.snackFailCurrency",
    ADD_CONTACT_FAILED: "navBar.snackFailContactAdd",
    DELETE_CONTACT_FAILED: "navBar.snackFailContactDelete",
    SET_LOCALE_FAILED: "navBar.snackFailLocale",
    ADD_TOKEN_FAILED: "navBar.snackFailTokenAdd",
    REMOVE_TOKEN_FAILED: "navBar.snackFailTokenRemove",
    DOWNLOAD_KEY_FAILED: "navBar.snackFailDownloadKey",
    CHANGE_NETWORK_FAILED: "navBar.snackFailNetworkChange",
    SWITCH_ACCOUNT_FAILED: "navBar.snackFailSwitchAccount",
    // TODO: load messages from locale
    ADD_TOKEN_DUPLICATE: "Unable to add token: Duplicate tokens",
  },
};
